import styled, { css } from 'styled-components';

export const Uppercase = css`
    text-transform: uppercase;
    letter-spacing: 0.4px;
`;

export const PlayUppercase = styled.p`
    ${Uppercase}
`;
